import { render } from "./NonCompositionApi.vue?vue&type=template&id=ba33889e"
import script from "./NonCompositionApi.vue?vue&type=script&lang=js"
export * from "./NonCompositionApi.vue?vue&type=script&lang=js"

import "./NonCompositionApi.vue?vue&type=style&index=0&id=ba33889e&lang=css"

import exportComponent from "C:\\files\\vue3_lesson_demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__